import React, { Fragment, useEffect, useState } from 'react';
import { getBondReportDataService, getIGSTDataService } from '../../../services/BOEReportService';
import { getBRCorelationService } from '../../../services/MasterService';
import { Table, Button, DatePicker, message, Select } from 'antd';
import { Col, Row } from 'react-bootstrap';
import { Excel } from 'antd-table-saveas-excel';
import Card from '../../../components/bootstrap/card';
import { getReportSummaryData, getAllAdminIECsService } from '../../../services/FileDataService';
import { getTodaysDate, formatToTwoDecimals } from '../../../utilities/utils';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import dayjs from 'dayjs';
import { useLocation } from 'react-router-dom';
import ReportDateFilter from '../../../components/ReportDateFilter';

import useColumnVisibility from '../../../hooks/useColumnVisibility';
import ColumnSelector from '../../../components/common/ColumnSelector';

const { RangePicker } = DatePicker;

const BondReport = ({ data }) => {
  const location = useLocation();
  // const iec_no = localStorage.getItem('iec_no');
  const [IECOptions, setIECOptions] = useState([]);
  const userRole = localStorage.getItem('role');
  const [selectedIEC, setSelectedIEC] = useState(
    localStorage.getItem('iec_no')
  );
  const [selectedIECName, setSelectedIECName] = useState(localStorage.getItem('name'))
  const [jsonData, setJsonData] = useState([]);
  const [isLoading2, setIsLoading2] = useState(false);
  const [summaryDashboardData, setSummaryDashboardData] = useState([]);
  const today = new Date();
  // Extract day, month, and year components
  const day = String(today.getDate()).padStart(2, '0');
  const month = String(today.getMonth() + 1).padStart(2, '0'); // January is 0!
  const year = today.getFullYear();

  // Concatenate components with hyphens
  const formattedDate = `${day}-${month}-${year}`;

  // ─── TABLE STYLES ────────────────────────────────────────────────────────────
  const tableStyles = `
    .bond-table .ant-table-thead > tr > th,
    .bond-summary-table .ant-table-thead > tr > th {
      white-space: normal !important;
      word-break: break-word !important;
      overflow: visible !important;
      text-overflow: unset !important;
      vertical-align: middle !important;
      line-height: 1.3 !important;
      padding-top: 8px !important;
      padding-bottom: 8px !important;
    }
    .bond-table .ant-table-tbody > tr > td,
    .bond-summary-table .ant-table-tbody > tr > td {
      white-space: nowrap;
    }
    .bond-table .ant-table-container,
    .bond-summary-table .ant-table-container {
      overflow-x: auto !important;
    }
    .bond-table .ant-table-header,
    .bond-summary-table .ant-table-header {
      overflow: hidden !important;
    }
    .bond-table .ant-table-sticky-holder,
    .bond-summary-table .ant-table-sticky-holder {
      overflow: hidden !important;
    }
  `;

  const [isValid, setIsValid] = useState(true); // Validation state
  const [billNo, setBillNo] = useState("");
  const [billNoOptions, setBillNoOptions] = useState([]); // Options for dropdown
  const [selectedBillNo, setSelectedBillNo] = useState(""); // Selected bill number
  const [branchCodeNames, setBranchCodeNames] = useState([]);
  const [selectedBranchCodes, setSelectedBranchCodes] = useState([]);
  const currentYear = dayjs().year();
  const defaultFrom = dayjs(`${currentYear}-01-01`);
  const defaultTo = dayjs(`${currentYear}-12-31`);
  const [dates, setDates] = useState(() => {
    // if report is opened through navigation from dashboard, then use those dates else default
    if (location.state?.passedDates?.length === 2) {
      return [
        dayjs(location.state.passedDates[0]),
        dayjs(location.state.passedDates[1]),
      ];
    }
    return [defaultFrom, defaultTo];
  });

  // Define columns for the table
  const columns = [
    { title: 'BUSINESS UNIT', dataIndex: 'business_unit', key: 'business_unit', header: 'BUSINESS UNIT', width: 160 , fixed: 'left' },
    { title: 'PLANT NAME', dataIndex: 'plant_name', key: 'plant_name', header: 'PLANT NAME', width: 150 , fixed: 'left' },
    { title: 'BOND NO.', dataIndex: 'bond_no', key: 'bond_no', header: 'BOND NO.', width: 115 },
    { title: 'BOND DT.', dataIndex: 'date', key: 'date', header: 'BOND DT.', width: 110 },
    { title: 'BOND TYPE', dataIndex: 'bond_type', key: 'bond_type', header: 'BOND TYPE', width: 120 },
    {
      title: 'BOND VALUE',
      dataIndex: 'bond_value',
      key: 'bond_value',
      header: 'BOND VALUE',
      align: 'right',
      width: 130,
      render: (text, record) => {
        return formatToTwoDecimals(text)
      }
    },
    { title: 'IEC/BR CODE', dataIndex: 'iec_br', key: 'iec_br', header: 'IEC/BR CODE', width: 150 },
    { title: 'PORT', dataIndex: 'port', key: 'port', header: 'PORT', width: 90 },
    { title: 'BOE NO.', dataIndex: 'be_no', key: 'be_no', header: 'BOE NO.', width: 115 },
    { title: 'BOE DT.', dataIndex: 'be_date', key: 'be_date', header: 'BOE DT.', width: 110 },
    {
      title: 'BOND DR. VALUE',
      dataIndex: 'boe_debt_amt',
      key: 'boe_debt_amt',
      header: 'BOND DR. VALUE',
      align: 'right',
      width: 160,
      render: (text, record) => {
        return formatToTwoDecimals(text)
      }
    },
    { title: 'FINAL REMARK', dataIndex: 'final_remark', key: 'final_remark', header: 'FINAL REMARK', width: 145 },
    { title: 'TEXTBOX 1', dataIndex: 'param1', key: 'param1', header: 'TEXTBOX 1', width: 125 },
    { title: 'TEXTBOX 2', dataIndex: 'param2', key: 'param2', header: 'TEXTBOX 2', width: 125 },
    { title: 'TEXTBOX 3', dataIndex: 'param3', key: 'param3', header: 'TEXTBOX 3', width: 125 },
    { title: 'TEXTBOX 4', dataIndex: 'param4', key: 'param4', header: 'TEXTBOX 4', width: 125 },
  ];

  const { visibleKeys, setVisibleKeys, filteredColumns, resetToDefault } =
    useColumnVisibility('BondReport', columns);

  const dashboardReportSummaryColumns = [
    { title: 'BOND NO.', dataIndex: 'bond_no', key: 'bond_no', header: 'BOND NO.', width: 115 },
    { title: 'BOND DT.', dataIndex: 'date', key: 'date', header: 'BOND DT.', width: 110 },
    { title: 'BOND TYPE', dataIndex: 'bond_type', key: 'bond_type', header: 'BOND TYPE', width: 120 },
    { title: 'BOND VALUE', dataIndex: 'bond_value', key: 'bond_value', header: 'BOND VALUE', align: 'right', width: 130 },
    {
      title: 'BOND DR. VALUE',
      dataIndex: 'bond_dr_value',
      key: 'bond_dr_value',
      header: 'BOND DR. VALUE',
      align: 'right',
      width: 160,
      render: (text, record) => {
        return formatToTwoDecimals(text)
      }
    },
    {
      title: 'BOND BAL',
      dataIndex: 'bond_bal_amt',
      key: 'bond_bal_amt',
      header: 'BOND BAL',
      align: 'right',
      width: 110,
      render: (text, record) => {
        return formatToTwoDecimals(text)
      }
    },
    { title: 'VALID TILL', dataIndex: 'expiry_date', key: 'expiry_date', header: 'VALID TILL', width: 120 },
    { title: 'VALID FOR (DAYS)', dataIndex: 'valid_for', key: 'valid_for', header: 'VALID FOR (DAYS)', align: 'right', width: 180 },
    {
      title: 'FINAL REMARK',
      dataIndex: 'final_remark',
      key: 'final_remark',
      header: 'FINAL REMARK',
      width: 145,
      render: (text, record) => (
        <span
          style={{ color: 'blue', cursor: 'pointer', textDecoration: 'underline' }}
          onClick={() => exportToExcel(text, record)}
        >
          {text}
        </span>
      ),
    }
  ];

  const getSummaryDashboard = async () => {
    const filters = {
      from_date: dates?.[0] ? dayjs(dates[0]).format("YYYY-MM-DD") : null,
      to_date: dates?.[1] ? dayjs(dates[1]).format("YYYY-MM-DD") : null,
      bill_no: billNo || null,
      br_code: selectedBranchCodes || null,
    };
    try {
      setIsLoading2(true)
      let reportTypes = 'BOND-Import';
      const response = await getReportSummaryData(reportTypes, filters, selectedIEC);

      if (response) {
        console.log("response: ", response.data);
        if (response.data) {
          setSummaryDashboardData(response.data);
          // Extract `bond no` and return unique values
          const uniqueNos = [...new Set(response.data.map(item => item.bond_no))];
          let i = 0;
          const options = uniqueNos.map(item => ({
            value: `${item}`,
            label: `${item}`,
            key: i++,
          }));
          setBillNoOptions(options)
        }
      }
      else {
        console.log("getSummaryDashboard :: no reponse")
      }
      setIsLoading2(false)
    }
    catch (err) {
      setIsLoading2(false)
      console.log(err);
    }
  }

  function formatDateToDDMMYY(dateString) {
    const date = new Date(dateString);
    console.log(dateString)
    if (isNaN(date.getTime())) {
      return ''; // Return empty string if the dateString is not a valid date
    }
    else {
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = String(date.getFullYear()).slice(-2);
      return `${day}/${month}/${year}`;
    }
  }

  const getDateOnly = (dateString) => {
    if (dateString && dateString.length !== 0) {
      const date = new Date(dateString);
      return date;
    }
    else {
      return '';
    }
  }

  const exportToExcel = async (filterRemark = null, record = null) => {
    let workbook = new ExcelJS.Workbook();
    let summaryWorksheet = workbook.addWorksheet('Summary');
    let worksheet = workbook.addWorksheet('Data');

    let data = jsonData;
    let summaryData = summaryDashboardData;

    // Apply filter if remark is clicked
    if (record) {
      // Add any keys here that are aggregated in the summary (e.g., amounts/totals) 
      // so they are not used for strict matching against raw data rows.
      const ignoreKeys = ['bond_dr_value', 'bond_bal_amt'];

      // Generic filter: match all keys present in both the record and the item
      const isMatch = (item, searchRecord) => {
        for (let key in searchRecord) {
          if (key === 'key' || ignoreKeys.includes(key)) continue; // Skip React 'key' prop and aggregated keys
          if (item.hasOwnProperty(key)) {
            if (item[key] !== searchRecord[key]) {
              return false;
            }
          }
        }
        return true;
      };

      data = data.filter(item => isMatch(item, record));
      summaryData = summaryData.filter(item => isMatch(item, record));
    } else if (filterRemark && typeof filterRemark === 'string') {
      data = data.filter(item => item.final_remark === filterRemark);
      summaryData = summaryData.filter(item => item.final_remark === filterRemark);
    }

    // Define columns for Excel export
    summaryWorksheet.columns = filteredSummaryColumns.map(col => ({
      header: col.header || col.title,
      key: col.dataIndex,
      width: 20
    }));
    // Apply styles to the header row (Row 1)
    summaryWorksheet.getRow(1).eachCell((cell) => {
      cell.font = { bold: true }; // Bold text
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFC000' }, // Yellow background
      };
      cell.alignment = { vertical: 'middle' }; // Center align
    });

    summaryData.forEach((obj) => {
      summaryWorksheet.addRow({
        ...obj,
        date: getDateOnly(obj.date)
      })
    })

    worksheet.columns = filteredColumns.map(col => ({
      header: col.header || col.title,
      key: col.dataIndex,
      width: 20
    }));
    // Apply styles to the header row (Row 1)
    worksheet.getRow(1).eachCell((cell) => {
      cell.font = { bold: true }; // Bold text
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFC000' }, // Yellow background
      };
      cell.alignment = { vertical: 'middle' }; // Center align
    });

    data.forEach((obj) => {
      worksheet.addRow({
        ...obj,
        date: getDateOnly(obj.date),
        sb_date: getDateOnly(obj.sb_date),
        leo_date: getDateOnly(obj.leo_date),
        date_of_realization: getDateOnly(obj.date_of_realization),
        bond_value: obj.bond_value ? parseFloat(obj.bond_value) : '',
        boe_debt_amt: obj.boe_debt_amt ? parseFloat(obj.boe_debt_amt) : '',
      })

    });

    // Generate Excel file
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

    // Use FileSaver to save the file
    const fileNameSuffix = filterRemark && typeof filterRemark === 'string' ? `_${filterRemark}` : '';
    saveAs(blob, `Lucrative's CIP DSS - Import Bond Ledger as on ${getTodaysDate()} of ${selectedIEC}${fileNameSuffix}.xlsx`);
  };

  const preprocessData = (data) => {
    return data.map(record => {
      if (record.sb_date) {
        const sbDate = new Date(record.sb_date);
        // Extract fiscal year from sb_date
        const fiscalYearStartYear = sbDate.getMonth() >= 3 ? sbDate.getFullYear() : sbDate.getFullYear() - 1;
        const fiscalYearEndYear = fiscalYearStartYear + 1;
        const fiscalYear = `AM${fiscalYearEndYear.toString().slice(-2)}`;
        record.FY = fiscalYear;
        record.sb_date = formatDateToDDMMYY(sbDate);
      } else {
        record.FY = '';
        record.sb_date = '';
        record.sbDate = '';

      }


      return record;
    });
  };

  const fetchData = async () => {
    const filters = {
      from_date: dates?.[0] ? dayjs(dates[0]).format("YYYY-MM-DD") : null,
      to_date: dates?.[1] ? dayjs(dates[1]).format("YYYY-MM-DD") : null,
      bill_no: billNo || null,
      br_code: selectedBranchCodes || null,
    };
    try {
      const response = await getBondReportDataService(selectedIEC, filters);
      // const data = JSON.parse(response);
      console.log(response);
      // Check if data is empty
      // if (Object.keys(data).length === 0 && data.constructor === Object) {
      //   throw new Error('Response data is empty');
      // }
      // console.log('data-',data)
      // const processedData = preprocessData(response.data);
      setJsonData(response);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  useEffect(() => {
    if (userRole === 'superadmin' || userRole === 'group_head') {
      getAdminIEC();
    }
    if (userRole === 'admin' || userRole === 'user') {
      fetchData();
      getSummaryDashboard();
    }
    if (selectedIEC) {
      getBRCorelationService(selectedIEC).then((response) => {
        setBranchCodeNames(response);
      });
    }
  }, []);

  // ─── useEffect 2: re-fetch branch codes when superadmin selects an IEC ────
  // This was missing — branch codes never updated after IEC selection
  useEffect(() => {
    if (selectedIEC) {
      getBRCorelationService(selectedIEC).then((response) => {
        setBranchCodeNames(response);
      });
    }
  }, [selectedIEC]);

  const handleDateChange = (value) => {
    setDates(value || []);
    if (value && value.length === 2) {
      const from_date = value[0];
      const to_date = value[1];

      // Validate that both dates are selected
      if (!from_date || !to_date) {
        setIsValid(false);
        return;
      }

      // Validate that the duration is within 1 year
      const oneYearLater = from_date.add(1, 'year');
      if (to_date.isAfter(oneYearLater)) {
        message.error("The selected duration should not exceed 1 year.");
        setIsValid(false);
        return;
      }

      setIsValid(true);
    } else {
      setIsValid(false);
    }
  };

  const handleSubmit = () => {
    if (!selectedIEC) {
      message.error("Please select an IEC");
      return;
    }

    if (dates.length === 2 && isValid) {
      fetchData();
      getSummaryDashboard();
    } else {
      message.error("Please select a valid date range");
    }
  };

  const getAdminIEC = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await getAllAdminIECsService(token);

      if (response?.data) {
        const options = response.data.map((item, index) => ({
          value: `${item.iec_no};${item.fullname}`,
          label: `${item.iec_no} (${item.fullname})`,
          key: index,
        }));
        setIECOptions(options);
      }
    } catch (err) {
      message.error("Failed to load IEC list");
    }
  };

  const handleIECSelection = (val) => {
    if (val) {
      const [iec_no, iec_name] = val.split(";");
      setSelectedIEC(iec_no);
      setSelectedIECName(iec_name);
    } else {
      setSelectedIEC(null);
      setSelectedIECName('');
    }
  };

  const handleBillNoSelection = (val) => {
    if (val) {
      setSelectedBillNo(val);
      setBillNo(val);
    } else {
      setSelectedBillNo("");  //Reset selected value
      setBillNo("");
    }
  };

  const filteredSummaryColumns = dashboardReportSummaryColumns.filter((col) => {
    const key = String(col.dataIndex || col.key);
    const isDefinedInDetail = columns.some((c) => String(c.dataIndex || c.key) === key);
    return isDefinedInDetail ? visibleKeys.includes(key) : true;
  });

  const handleBranchCodeSelection = (values) => {
    setSelectedBranchCodes(values);
  };

  return (
    <Fragment>
      <style>{tableStyles}</style>
      <Row>
        <Col sm="12">
          <Card>
            <Card.Header className="d-flex justify-content-between">
              <div className="header-title">
                <h4 className="card-title">Lucrative's CIP DSS  -  Import Bond Ledger as on  {formattedDate} of {selectedIECName}</h4>
              </div>
              <div className="d-flex align-items-center gap-2">
                <ColumnSelector
                  allColumns={columns}
                  visibleKeys={visibleKeys}
                  setVisibleKeys={setVisibleKeys}
                  onReset={resetToDefault}
                />
                <button
                  className='btn btn-primary cip-btn-submit'
                  onClick={exportToExcel}
                >
                  Export to Excel
                </button>
              </div>
            </Card.Header>
            <Card.Body className="d-flex justify-content-start align-items-center gap-2 ps-4">
              {(userRole === 'superadmin' || userRole === 'group_head') && (
                <Select
                  showSearch
                  placeholder="Select IEC"
                  onChange={handleIECSelection}
                  allowClear
                  options={IECOptions}
                  style={{ width: '300px' }}
                />
              )}
              <ReportDateFilter dates={dates} onChange={handleDateChange} />
              <Select
                showSearch
                placeholder="Select Auth No"
                value={selectedBillNo} // Controlled by state
                allowClear
                style={{ width: 250 }}
                filterOption={(input, option) =>
                  (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
                }
                onChange={handleBillNoSelection} // Update state when an option is selected
                options={billNoOptions} // Dynamically populated options
              />
              <Select
                mode="multiple"
                allowClear
                style={{ width: 250 }}
                placeholder="Select Branch Code"
                onChange={handleBranchCodeSelection}
                options={branchCodeNames.map((item) => ({
                  value: item.branch_code,
                  label: `${item.branch_code} / ${item.plant_name} (${item.business_unit})`,
                }))}
              />
              <Button type="primary" className="cip-btn-submit"
                onClick={handleSubmit}>
                Submit
              </Button>
            </Card.Body>
            <Card.Body className="px-0 report-page">
              <Table
                className="bond-summary-table"
                columns={filteredSummaryColumns}
                dataSource={summaryDashboardData}
                pagination={false}
                loading={isLoading2}
                bordered
                scroll={{ x: 'max-content' }}
                
              />
              <hr />
              <Table
                className="bond-table"
                bordered
                columns={filteredColumns}
                dataSource={jsonData}
                pagination={{ showTotal: (total) => `Total ${total} records`, showSizeChanger: true }}
                scroll={{ x: 'max-content' }}
                
              />
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Fragment>
  );
};

export default BondReport;
